import { createFileRoute, Outlet } from '@tanstack/react-router';

// Passthrough layout for all report pages.
export const Route = createFileRoute('/(client)/report/(pages)')({
  component: () => <Outlet />,
});
